var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMemberTalk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#61D81D;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_2.\\u767D\\u7248-\\u6703\\u54E1\\u9078\\u55AE",
    transform: "translate(-203.000000, -480.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button",
    transform: "translate(193.000000, 470.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st0",
    d: "M21.1,30.3c-3,0-5.6-2.5-5.6-5.6s2.5-5.6,5.6-5.6s5.6,2.5,5.6,5.6C26.7,27.8,24.2,30.3,21.1,30.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "st1",
    d: "M26.3,12.7c1.3,0,2.4,1.1,2.4,2.4v7.7c0,1.3-1.1,2.4-2.4,2.4h-7.6l-5,3.5v-3.5 c-1.3,0-2.4-1.1-2.4-2.4v-7.7c0-1.3,1.1-2.4,2.4-2.4H26.3z M27.7,22.8v-7.7c0-0.8-0.6-1.4-1.4-1.4H13.7c-0.8,0-1.4,0.6-1.4,1.4 v7.7c0,0.8,0.6,1.4,1.4,1.4h1v2.6l3.7-2.6h7.9C27.1,24.1,27.7,23.5,27.7,22.8z M16,16.3h8.1v1H16V16.3z M16,18.4h8.1v1H16V18.4z  M16,20.6h8.1v1H16V20.6z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMemberTalk);
export default __webpack_public_path__ + "static/media/icon-member-talk.8abe549404faf3122675c449a6fae051.svg";
export { ForwardRef as ReactComponent };